(() => {
  document.documentElement.classList.remove('no-js');
  const q=(s,c=document)=>c.querySelector(s), qa=(s,c=document)=>[...c.querySelectorAll(s)];
  const drawer=q('[data-cart-drawer]');
  const openDrawer=()=>{if(!drawer)return;drawer.setAttribute('aria-hidden','false');document.body.classList.add('drawer-open');q('[data-drawer-close]',drawer)?.focus()};
  const closeDrawer=()=>{if(!drawer)return;drawer.setAttribute('aria-hidden','true');document.body.classList.remove('drawer-open')};
  qa('[data-cart-toggle]').forEach(b=>b.addEventListener('click',openDrawer)); qa('[data-drawer-close]').forEach(b=>b.addEventListener('click',closeDrawer));
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeDrawer();q('[data-search-panel]')?.setAttribute('hidden','')}});

  const normalizeShippingCopy=(scope=document)=>{
    const walker=document.createTreeWalker(scope,NodeFilter.SHOW_TEXT);
    const nodes=[];
    while(walker.nextNode())nodes.push(walker.currentNode);
    nodes.forEach(node=>{
      if(!node.nodeValue)return;
      node.nodeValue=node.nodeValue
        .replace(/fri frakt på alla beställningar över 399 kr/gi,'fri frakt på alla beställningar över 599 kr')
        .replace(/fri frakt över 399 kr/gi,'fri frakt över 599 kr')
        .replace(/fri frakt vid köp över 399[:-]?/gi,'fri frakt vid köp över 599 kr');
    });
  };
  normalizeShippingCopy();

  const bindQuickAdd=(scope=document)=>{
    qa('.quick-add',scope).forEach(form=>{
      if(form.dataset.quickAddBound==='true')return;
      form.dataset.quickAddBound='true';
      form.addEventListener('submit',async e=>{e.preventDefault();const btn=q('button',form);btn.disabled=true;try{const r=await fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});if(!r.ok)throw Error();const cart=await fetch('/?section_id=cart-drawer').then(x=>x.text());const content=q('[data-cart-drawer-content]',drawer);const parsed=new DOMParser().parseFromString(cart,'text/html');if(content&&q('[data-cart-drawer-content]',parsed))content.innerHTML=q('[data-cart-drawer-content]',parsed).innerHTML;const count=await fetch('/cart.js').then(x=>x.json());qa('[data-cart-count]').forEach(x=>x.textContent=count.item_count);openDrawer()}catch{btn.textContent='Försök igen'}finally{btn.disabled=false}})
    })
  };
  bindQuickAdd();

  const searchPanel=q('[data-search-panel]'), searchInput=q('[data-predictive-input]');q('[data-search-toggle]')?.addEventListener('click',()=>{const h=searchPanel.hasAttribute('hidden');searchPanel.toggleAttribute('hidden',!h);if(h)searchInput?.focus()});
  let timer; searchInput?.addEventListener('input',e=>{clearTimeout(timer);const term=e.target.value.trim(),target=q('[data-predictive-results]');if(!term){target.innerHTML='';return}timer=setTimeout(async()=>{try{const res=await fetch(`/search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection&page_limit=6&section_id=predictive-search`).then(r=>r.text());target.innerHTML=res}catch{target.innerHTML='<p>Det gick inte att hämta sökförslag.</p>'}},250)});
  q('[data-menu-toggle]')?.addEventListener('click',e=>{const panel=q('[data-mobile-menu]'),state=e.currentTarget.getAttribute('aria-expanded')==='true';e.currentTarget.setAttribute('aria-expanded',String(!state));panel.hidden=state});
  q('[data-filter-toggle]')?.addEventListener('click',()=>q('[data-filters]')?.classList.toggle('is-open'));
  qa('[data-address-toggle]').forEach(b=>b.addEventListener('click',()=>{const el=document.getElementById(b.dataset.addressToggle);if(el)el.hidden=!el.hidden}));

  const observer='IntersectionObserver'in window?new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in-view');observer.unobserve(e.target)}}),{threshold:.15}):null;
  const revealFadeIns=(scope=document)=>qa('.fade-in',scope).forEach(el=>observer?observer.observe(el):el.classList.add('in-view'));
  revealFadeIns();

  document.addEventListener('ellivie:product-grid-updated',e=>{
    const scope=e.target instanceof Element?e.target:document;
    qa('.fade-in',scope).forEach(el=>el.classList.add('in-view'));
    bindQuickAdd(scope);
    normalizeShippingCopy(scope);
  });

  const getActiveSeries=()=>{
    const active=q('[data-product-series-link].is-active');
    if(!active)return null;
    try{
      const path=new URL(active.href,window.location.origin).pathname.replace(/\/$/,'');
      const match=path.match(/^\/collections\/([^/]+)$/);
      return match?decodeURIComponent(match[1]):null;
    }catch{return null}
  };

  const getCurrentHub=()=>{
    const match=window.location.pathname.replace(/\/$/,'').match(/^\/collections\/(posters|rum)$/);
    if(!match)return null;
    return match[1];
  };

  const buildHubContext=()=>{
    const hub=getCurrentHub();
    if(!hub)return null;
    const series=getActiveSeries()||new URLSearchParams(window.location.search).get('series');
    if(!series)return null;
    const active=q('[data-product-series-link].is-active');
    const returnUrl=new URL(`/collections/${hub}`,window.location.origin);
    returnUrl.searchParams.set('series',series);
    const current=new URL(window.location.href);
    ['page','sort_by'].forEach(key=>{
      const value=current.searchParams.get(key);
      if(value)returnUrl.searchParams.set(key,value);
    });
    return {
      hub,
      hubTitle:hub==='rum'?'Rum':'Posters',
      series,
      seriesTitle:active?.textContent?.trim()||series.replace(/-/g,' '),
      returnUrl:returnUrl.pathname+returnUrl.search+returnUrl.hash
    };
  };

  const saveHubReturnState=(productLink)=>{
    const context=buildHubContext();
    if(!context)return;
    history.replaceState({collectionHub:context.hub,series:context.series},'',context.returnUrl);
    try{sessionStorage.setItem('ellivieProductReturnContext',JSON.stringify(context))}catch{}
    if(productLink){
      try{
        const productUrl=new URL(productLink.href,window.location.origin);
        productUrl.searchParams.set('from',context.hub);
        productUrl.searchParams.set('series',context.series);
        productLink.href=productUrl.pathname+productUrl.search+productUrl.hash;
      }catch{}
    }
  };

  document.addEventListener('click',event=>{
    const productLink=event.target.closest('[data-product-grid] a[href*="/products/"]');
    if(!productLink)return;
    if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    saveHubReturnState(productLink);
  });

  const restoreProductCollectionContext=()=>{
    if(!window.location.pathname.includes('/products/'))return;
    const params=new URLSearchParams(window.location.search);
    const from=params.get('from');
    const urlSeries=params.get('series');
    let context=null;
    try{context=JSON.parse(sessionStorage.getItem('ellivieProductReturnContext')||'null')}catch{}

    if(from==='posters'||from==='rum'){
      const matchesStored=context&&context.hub===from&&(!urlSeries||context.series===urlSeries);
      if(!matchesStored){
        context={
          hub:from,
          hubTitle:from==='rum'?'Rum':'Posters',
          series:urlSeries||'',
          seriesTitle:(urlSeries||'').replace(/-/g,' '),
          returnUrl:`/collections/${from}${urlSeries?`?series=${encodeURIComponent(urlSeries)}`:''}`
        };
      }
    }

    if(!context||!context.returnUrl)return;
    const breadcrumb=q('.product-page .breadcrumbs');
    if(!breadcrumb)return;
    const productTitle=breadcrumb.querySelector('span')?.textContent?.trim()||document.title;
    breadcrumb.innerHTML='';
    const home=document.createElement('a');home.href='/';home.textContent='Hem';breadcrumb.append(home,' / ');
    const hubLink=document.createElement('a');hubLink.href=`/collections/${context.hub}`;hubLink.textContent=context.hubTitle;breadcrumb.append(hubLink,' / ');
    if(context.seriesTitle){const series=document.createElement('a');series.href=context.returnUrl;series.textContent=context.seriesTitle;breadcrumb.append(series,' / ');}
    const current=document.createElement('span');current.textContent=productTitle;breadcrumb.append(current);
  };
  restoreProductCollectionContext();

  const bindReferralWelcomeRecovery=()=>{
    const popup=q('[data-referral-popup]');
    if(!popup||popup.dataset.welcomeRecoveryBound==='true')return;
    popup.dataset.welcomeRecoveryBound='true';
    const codeEl=q('[data-welcome-code-value]',popup);
    const codeButton=q('[data-copy-welcome-code]',popup);
    const status=q('[data-welcome-status]',popup);
    if(!codeEl||!codeButton||!status)return;

    let retryButton=q('[data-referral-retry]',popup);
    if(!retryButton){
      retryButton=document.createElement('button');
      retryButton.type='button';
      retryButton.dataset.referralRetry='';
      retryButton.textContent='Försök igen';
      retryButton.style.cssText='display:none;margin-top:10px;border:0;border-radius:10px;padding:10px 14px;background:#23211e;color:#fff;font:inherit;font-weight:700;cursor:pointer';
      codeButton.insertAdjacentElement('afterend',retryButton);
    }

    const getOwnCode=()=>{
      try{return (localStorage.getItem('ellivieReferralCode')||'').trim().toUpperCase()}catch{return ''}
    };

    const setLoading=()=>{
      codeButton.disabled=true;
      codeEl.textContent='Skapar kod…';
      status.textContent='Vi aktiverar din personliga rabattkod hos Shopify…';
      retryButton.style.display='none';
    };

    const setError=(message)=>{
      codeButton.disabled=true;
      codeEl.textContent='Koden är inte klar än';
      status.textContent=message||'Rabattkoden kunde inte aktiveras just nu.';
      retryButton.style.display='inline-block';
    };

    const setReady=(code)=>{
      codeEl.textContent=code;
      codeButton.disabled=false;
      codeButton.dataset.code=code;
      status.textContent='Din personliga kod är aktiverad och kan användas en gång.';
      retryButton.style.display='none';
    };

    const check=async()=>{
      const ownCode=getOwnCode();
      if(!ownCode){setError('Vi hittar inte din registreringskod i webbläsaren. Registrera dig igen eller kontakta oss så hjälper vi dig.');return}
      setLoading();
      try{
        const response=await fetch(`https://ellivie-ai-studio.onrender.com/api/referral-status?code=${encodeURIComponent(ownCode)}&_=${Date.now()}`,{cache:'no-store'});
        const data=await response.json().catch(()=>null);
        if(!response.ok)throw new Error(data?.welcomeError||`HTTP ${response.status}`);
        const progress=q('[data-referral-progress]',popup);
        if(progress)progress.textContent=`${data?.count||0} / ${data?.target||10}`;
        if(data?.welcomeReady&&data?.welcomeCode){setReady(data.welcomeCode);return}
        setError(data?.welcomeError||'Registreringen är klar, men rabattkoden är ännu inte färdig. Klicka på Försök igen om en liten stund.');
      }catch(error){
        setError(error?.message==='Failed to fetch'?'Vi kunde inte nå kodtjänsten just nu. Klicka på Försök igen.':(error?.message||'Rabattkoden kunde inte hämtas just nu.'));
      }
    };

    retryButton.addEventListener('click',check);

    const observer=new MutationObserver(()=>{
      const success=q('[data-referral-success-view]',popup);
      if(success&&!success.hasAttribute('hidden')&&!codeButton.dataset.code){
        observer.disconnect();
        window.setTimeout(check,300);
      }
    });
    observer.observe(popup,{subtree:true,attributes:true,attributeFilter:['hidden']});

    const success=q('[data-referral-success-view]',popup);
    if(success&&!success.hasAttribute('hidden')&&!codeButton.dataset.code)window.setTimeout(check,300);
  };
  bindReferralWelcomeRecovery();

  const form=q('.product-form'),sticky=q('[data-sticky-atc]');if(form&&sticky&&'IntersectionObserver'in window){new IntersectionObserver(([e])=>{sticky.hidden=e.isIntersecting},{threshold:.1}).observe(form);q('[data-sticky-atc-button]')?.addEventListener('click',()=>q('button[type="submit"]',form)?.click())}
  const rec=q('[data-recommendations]');if(rec?.dataset.productId)fetch(`/recommendations/products?section_id=product-recommendations&product_id=${rec.dataset.productId}&limit=3`).then(r=>r.text()).then(html=>rec.innerHTML=html).catch(()=>{});
})();
